import { useContext } from 'react';
import { EWIPDashboardScreenContext } from '../DashboardProvider';
import { Button, ButtonGroup, Card, CircularProgress, Grid } from '@material-ui/core';
import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts';
import './wipDashStyle.scss';
import { WipNoRecord, WipScreenLoader } from './wipDash-Loader';

const WipDashboardBranch = ({ onChartClickHandler }) => {
    const { state, array, handlePieCard, handleChangeAssignedUser, COLORS, redirectToAssignedJobs } = useContext(EWIPDashboardScreenContext);
    return (
        <>
            {state.showHeaderLoader ? (
                <div className="wip-dash-Card">
                    <WipScreenLoader />
                </div>
            ) : (
                <Card className="wip-dash-Card" style={{ position: 'relative' }}>
                    <Grid container alignItems="center" spacing={2} justifyContent={array.selectedPieChartType == 'A' ? 'space-between' : 'flex-start'}>
                        <Grid container item xs={11} alignItems="center" spacing={1} style={{ margin: 'auto' }}>
                            <Grid item xs={12} sm={array.selectedPieChartType == 'A' ? 6 : 12}>
                                <div style={{ textAlign: 'left' }}>
                                    <ButtonGroup color="secondary" aria-label="outlined primary button group" size="small">
                                        <Button
                                            // key={i}
                                            variant={array.selectedPieChartType == 'A' ? 'contained' : 'outlined'}
                                            onClick={() => handlePieCard('A')}
                                            style={{ fontSize: 10 }}
                                        >
                                            Assigned Jobs
                                        </Button>
                                        <Button
                                            // key={i}
                                            variant={array.selectedPieChartType == 'B' ? 'contained' : 'outlined'}
                                            onClick={() => handlePieCard('B')}
                                            style={{ fontSize: 10 }}
                                        >
                                            By Branch
                                        </Button>
                                    </ButtonGroup>
                                </div>
                            </Grid>

                            {array.selectedPieChartType == 'A' && (
                                <Grid item xs={12} sm={6}>
                                    <div>
                                        <select onChange={handleChangeAssignedUser} className="selectclass" value={array.byAssignedUser}>
                                            <option value={'Default'}>All Users</option>
                                            {state.assignedUserList.map((btn, i) => {
                                                return (
                                                    <option key={btn.userID} value={btn.userID}>
                                                        {btn.userName}{' '}
                                                    </option>
                                                );
                                            })}
                                        </select>
                                    </div>
                                </Grid>
                            )}
                        </Grid>

                        <Grid item xs={12}>
                            {array.selectedPieChartType == 'B' ? (
                                state.chartdata.length == 0 ? (
                                    <WipNoRecord />
                                ) : (
                                    <>
                                        <div className="pieChartSize">
                                            <ResponsiveContainer>
                                                <PieChart>
                                                    <Pie
                                                        data={state.chartdata}
                                                        cx={70}
                                                        cy={45}
                                                        paddingAngle={3}
                                                        outerRadius={45}
                                                        innerRadius={25}
                                                        fill="#8884d8"
                                                        dataKey="value"
                                                    >
                                                        {state.chartdata.map((entry, index) => (
                                                            <>
                                                                <Cell
                                                                    key={entry.name}
                                                                    fill={COLORS[index % COLORS.length]}
                                                                    style={{ cursor: 'pointer' }}
                                                                    onClick={() => onChartClickHandler({ workflowID: 'All', bn: entry.name }, true)}
                                                                />
                                                            </>
                                                        ))}
                                                    </Pie>
                                                </PieChart>
                                            </ResponsiveContainer>
                                        </div>
                                        <div className="pie-branch-list custom-scroll">
                                            {state?.chartdata.map((m, i) => {
                                                let color = COLORS[i];
                                                return (
                                                    <div style={{ padding: 0 }} key={m.value}>
                                                        <div className="branch-List-box">
                                                            {' '}
                                                            <div
                                                                style={{
                                                                    background: color,
                                                                    height: 10,
                                                                    width: 10,
                                                                    marginTop: 4
                                                                }}
                                                            ></div>
                                                            <div style={{ fontWeight: 700 }}>&nbsp;{m.value}</div>
                                                            <div>&nbsp;{m.name}</div>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </>
                                )
                            ) : array.assignedJobs.length == 0 ? (
                                <WipNoRecord />
                            ) : (
                                <>
                                    <div className="pieChartSize">
                                        <ResponsiveContainer>
                                            <PieChart>
                                                <text
                                                    x={75}
                                                    y={50}
                                                    textAnchor="middle"
                                                    dominantBaseline="middle"
                                                    fontWeight="bold"
                                                    onClick={() => redirectToAssignedJobs(null, true)}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    {/* Total: */}
                                                    {array.assignedJobsTotals}
                                                </text>
                                                <Pie
                                                    data={array.assignedJobs}
                                                    cx={70}
                                                    cy={45}
                                                    paddingAngle={3}
                                                    outerRadius={45}
                                                    innerRadius={25}
                                                    fill="#8884d8"
                                                    dataKey="total"
                                                >
                                                    {array.assignedJobs.map((entry, index) => (
                                                        <>
                                                            <Cell
                                                                key={`cell-${index}`}
                                                                fill={COLORS[index % COLORS.length]}
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() => redirectToAssignedJobs(entry, false)}
                                                            />
                                                        </>
                                                    ))}
                                                </Pie>
                                            </PieChart>
                                        </ResponsiveContainer>
                                    </div>
                                    <div className=" pie-job-list custom-scroll">
                                        {array.assignedJobs.map((m, i) => {
                                            let color = COLORS[i];
                                            return (
                                                <div style={{ padding: 0 }} key={m.workflow}>
                                                    <div
                                                        style={{
                                                            fontSize: 13,
                                                            maxWidth: 210,
                                                            minWidth: 110,
                                                            display: 'flex',
                                                            justifyContent: 'flex-start'
                                                        }}
                                                    >
                                                        {' '}
                                                        <div
                                                            style={{
                                                                background: color,
                                                                height: 10,
                                                                width: 10,
                                                                marginTop: 4
                                                            }}
                                                        ></div>
                                                        <div style={{ fontWeight: 700 }}>&nbsp;{m.total}</div>
                                                        <div>&nbsp;{m.workflow}</div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </>
                            )}
                        </Grid>
                    </Grid>
                </Card>
            )}
        </>
    );
};

export default WipDashboardBranch;
